import { DEFAULT_CURRENCY } from 'common/constants';

type FormatMoneyParams = {
  num?: number,
  currency: string,
  fractionDigits?: number,
  round?: boolean,
}

export function formatMoney(params: FormatMoneyParams = { currency: DEFAULT_CURRENCY }) {
  const { num, currency = DEFAULT_CURRENCY, fractionDigits, round = true } = params;
  // Only missing/NaN values are blank — a legitimate 0 formats as a currency zero.
  if (num == null || isNaN(num)) {
    return '';
  }

  if (currency === 'USD_2080') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format(Math.round((num + Number.EPSILON) * 100) / 100);
  }

  const roundedNumber = round ? Math.round(num) : num;

  return new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: fractionDigits || 0 }).format(roundedNumber);
}

export const nthNumber = (number: number) => {
  if (number > 3 && number < 21) return 'th';
  switch (number % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};
